/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-23 17:51:48
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-10-18 11:49:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/Config/index.tsx
 */
import { LineCollapse } from '@/src/components';
import { Button } from '@/src/components/Antd';
import { errCodesMap } from '@/src/error/code';
import { TabBarItem, TabBarSetting } from '@/src/types/common/SalesChannel';
import { PlusOutlined } from '@ant-design/icons';
import { Moment } from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { ErrorDisplay } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import CloneBtn from 'src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/CloneButton';
import TimerPickerModal from '../../Components/TimePickerModal';
import Item from '../Item';
import {
  getDefaultSetting,
  getNewSettingList,
  getOccupiedRanges,
  getOpenList,
  getSettingList,
  getTimeData,
  getTimeZone,
  onAddNewCustomerSetting,
  onCustomSettingChange,
  onDefaultChange,
  onDeleteTabBarSetting,
  onDuplicateSetting,
  onFinishAddingNew,
  onNewSettingChange,
  onOpenTabBarSetting,
  onRestoreDefaultSetting,
} from '../slice';
import TabModal from '../TabModal';
import { groupingTabBarSettingByTime } from '../tools';
import { validateTabs, validation } from '../validation';
import { handleOnGetCurrentSCTimezone } from '@/src/tools/tools';
import styles from './style.module.less';

function Config() {
  const isPrimary = useSelector(isPrimaryLanguage());
  const scTimezoneUTC = handleOnGetCurrentSCTimezone();
  const [group, setGroup] = useState(['InUse', 'Pending', 'Previous']);
  const [isAdd, setIsAdd] = useState(false);
  const [visible, setVisible] = useState(false);
  const [timeVisible, setTimeVisible] = useState(false);
  const [currentTab, setTab] = useState<{ id: string; tab: TabBarItem }>({
    id: '',
    tab: null,
  });

  const dispatch = useDispatch();
  const defaultSetting = useSelector(getDefaultSetting());
  const settingList = useSelector(getSettingList());
  const newSettingList = useSelector(getNewSettingList());
  const openList = useSelector(getOpenList());
  const timeZone = useSelector(getTimeZone());
  const occupiedRange = useSelector(getOccupiedRanges());
  const date = useSelector(getTimeData());

  const handleSettingChange = (type: string, settings: TabBarSetting) => {
    if (type === 'default') {
      dispatch(onDefaultChange(settings));
    } else if (type === 'new') {
      dispatch(onNewSettingChange(settings));
    } else if (type === 'other') {
      dispatch(onCustomSettingChange(settings));
    }
  };

  const handleAddTab = (id: string) => {
    setVisible(true);
    setIsAdd(true);
    setTab({ id, tab: null });
  };

  const handleEditTab = (id: string, tab: TabBarItem) => {
    setVisible(true);
    setIsAdd(false);
    setTab({ id, tab });
  };

  const handleSettingTime = () => {
    setTimeVisible(true);
  };

  const handleDeleteItem = (id: string) => {
    dispatch(onDeleteTabBarSetting(id));
  };

  const handleDuplicate = (id: string) => {
    dispatch(onDuplicateSetting(id));
  };

  const handleResetDS = () => {
    dispatch(onRestoreDefaultSetting());
  };

  const handleCancelDS = () => void 0;

  const handleOpenGroup = (keys: Array<string>) => {
    console.log('handleOpenGroup, keys=', keys);
    if (keys.length == 0) {
      setGroup(['InUse']);
    } else {
      setGroup(keys);
    }
  };

  const handleCloseTimerModal = () => {
    setTimeVisible(false);
  };

  const handleSubmitTimeModal = (start: Moment, end: Moment) => {
    const id =
      Array.isArray(openList) && openList.length !== 0 ? openList[0] : '';
    const index = Array.isArray(settingList)
      ? settingList.findIndex((t) => t.id === id)
      : -1;
    const index1 = Array.isArray(newSettingList)
      ? newSettingList.findIndex((t) => t.id === id)
      : -1;
    if (index !== -1) {
      const item = {
        ...settingList[index],
        startTime: start,
        endTime: end,
      };
      dispatch(onCustomSettingChange(item));
    }
    if (index1 !== -1) {
      const item = {
        ...newSettingList[index1],
        startTime: start,
        endTime: end,
      };
      dispatch(onNewSettingChange(item));
    }
    handleCloseTimerModal();
  };

  const resetTimeModal = () => void 0;

  const handleModalClose = () => {
    setVisible(false);
  };

  const handleOpenItem = (id: string) => {
    dispatch(onOpenTabBarSetting(id));
    dispatch(onFinishAddingNew({}));
  };

  const handleChangeTab = (tab: TabBarItem) => {
    const { id } = currentTab;
    const constructResult = (tab, tabs: Array<any>) => {
      const result = [...tabs];
      const tabIndex = tabs.findIndex((t) => t.draggableId === tab.draggableId);
      if (tabIndex === -1) {
        result.push(tab);
      } else {
        result[tabIndex] = tab;
      }
      return result;
    };
    if (id === 'default') {
      const { tabs } = defaultSetting;
      const result = constructResult(tab, tabs);
      dispatch(onDefaultChange({ ...defaultSetting, tabs: result }));
    } else {
      const index = Array.isArray(settingList)
        ? settingList.findIndex((v) => v.id === id)
        : -1;
      const newListIndex = Array.isArray(newSettingList)
        ? newSettingList.findIndex((v) => v.id === id)
        : -1;
      if (index !== -1) {
        const item = settingList[index];
        const { tabs } = item;
        const result = constructResult(tab, tabs);
        dispatch(onCustomSettingChange({ ...item, tabs: result }));
      }
      if (newListIndex !== -1) {
        const item = newSettingList[newListIndex];
        const { tabs } = item;
        const result = constructResult(tab, tabs);
        dispatch(onNewSettingChange({ ...item, tabs: result }));
      }
    }
    handleModalClose();
  };

  const handleAddNewTabSetting = () => {
    dispatch(onAddNewCustomerSetting());
  };

  const resetModal = () => {
    setIsAdd(false);
    setTab({ id: '', tab: null });
  };

  const getItemError = (tabBar: TabBarSetting) => {
    const err = validation(tabBar, isPrimary);
    return err.map((v) => errCodesMap[v]);
  };

  const Error = (display: boolean, open: boolean, err: any) => {
    if (display) {
      return <ErrorDisplay open={open} err={err} />;
    } else {
      return <></>;
    }
  };

  const list = groupingTabBarSettingByTime(
    defaultSetting,
    settingList,
    scTimezoneUTC,
  );

  const renderSettings = (list: Array<TabBarSetting>) => {
    return (
      <>
        {list.map((setting: TabBarSetting) => {
          return (
            <div className={styles.item} key={setting.id}>
              <Item
                isPrimary={isPrimary}
                id={setting.id}
                data={setting}
                isDefault={setting.isDefault}
                open={openList.indexOf(setting.id) !== -1}
                onDataChange={handleSettingChange.bind(
                  this,
                  setting.isDefault ? 'default' : 'other',
                )}
                onAddTab={handleAddTab.bind(
                  this,
                  setting.isDefault ? 'default' : setting.id,
                )}
                onEditTab={handleEditTab.bind(
                  this,
                  setting.isDefault ? 'default' : setting.id,
                )}
                onSettingTime={handleSettingTime}
                onDeleteItem={handleDeleteItem}
                onDuplicate={handleDuplicate}
                onResetDefaultSetting={handleResetDS}
                onCancelResetDefaultSetting={handleCancelDS}
                onOpen={handleOpenItem}
                timeZone={timeZone}
                showError={
                  setting.showError && getItemError(setting).length !== 0
                }
                err={Error(
                  setting.showError,
                  openList.indexOf(setting.id) !== -1,
                  getItemError(setting),
                )}
                tabsError={validateTabs(setting.tabs, isPrimary)}
              />
            </div>
          );
        })}
      </>
    );
  };
  const List = [
    {
      headerText: 'Active',
      key: 'InUse',
      content: renderSettings(
        list.inUse.filter((v) => !v.isDefault).length !== 0
          ? list.inUse
          : [defaultSetting],
      ),
      // hideStatusText: true,
    },
    {
      headerText: 'Pending',
      key: 'Pending',
      content: renderSettings(list.pending),
      // hideStatusText: true,
    },
    {
      headerText: 'Previous',
      key: 'Previous',
      content: renderSettings(list.previous),
      // hideStatusText: true,
    },
  ];
  return (
    <div className={styles.container}>
      {list.inUse.filter((v) => !v.isDefault).length !== 0 && (
        <div className={styles.default}>
          <Item
            isPrimary={isPrimary}
            id={defaultSetting.id}
            data={defaultSetting}
            isDefault={true}
            open={openList.indexOf(defaultSetting.id) !== -1}
            onDataChange={handleSettingChange.bind(this, 'default')}
            onAddTab={handleAddTab.bind(this, 'default')}
            onEditTab={handleEditTab.bind(this, 'default')}
            onSettingTime={handleSettingTime}
            onDeleteItem={handleDeleteItem}
            onDuplicate={handleDuplicate}
            onResetDefaultSetting={handleResetDS}
            onCancelResetDefaultSetting={handleCancelDS}
            onOpen={handleOpenItem}
            timeZone={timeZone}
            showError={
              defaultSetting.showError &&
              getItemError(defaultSetting).length !== 0
            }
            err={Error(
              defaultSetting.showError,
              openList.indexOf(defaultSetting.id) !== -1,
              getItemError(defaultSetting),
            )}
            tabsError={validateTabs(defaultSetting.tabs, isPrimary)}
          />
        </div>
      )}
      {isPrimary ? (
        <div className={styles.new}>
          <Button
            type='primary'
            block
            icon={<PlusOutlined className={styles.icon} />}
            className={styles.btnNew}
            onClick={handleAddNewTabSetting}>
            <span>New Tab Bar</span>
          </Button>
        </div>
      ) : (
        <CloneBtn />
      )}

      <div className={styles.newSetting}>
        {newSettingList.map((setting: TabBarSetting) => {
          return (
            <div className={styles.item} key={setting.id}>
              <Item
                isPrimary={isPrimary}
                id={setting.id}
                data={setting}
                isDefault={setting.isDefault}
                open={openList.indexOf(setting.id) !== -1}
                onDataChange={handleSettingChange.bind(this, 'new')}
                onAddTab={handleAddTab.bind(this, setting.id)}
                onEditTab={handleEditTab.bind(this, setting.id)}
                onSettingTime={handleSettingTime}
                onDeleteItem={handleDeleteItem}
                onDuplicate={handleDuplicate}
                onResetDefaultSetting={handleResetDS}
                onCancelResetDefaultSetting={handleCancelDS}
                onOpen={handleOpenItem}
                timeZone={timeZone}
                showError={
                  setting.showError && getItemError(setting).length !== 0
                }
                err={Error(
                  setting.showError,
                  openList.indexOf(setting.id) !== -1,
                  getItemError(setting),
                )}
                tabsError={validateTabs(setting.tabs, isPrimary)}
              />
            </div>
          );
        })}
      </div>
      <div className={styles.tabs}>
        <LineCollapse open={group} setOpen={handleOpenGroup} data={List} />
      </div>
      <TabModal
        hideLink={!isPrimary}
        visible={visible}
        onCancel={handleModalClose}
        isAdd={isAdd}
        onSubmit={handleChangeTab}
        data={currentTab.tab}
        onReset={resetModal}
      />
      <TimerPickerModal
        visible={timeVisible}
        onCancel={handleCloseTimerModal}
        onSubmit={handleSubmitTimeModal}
        afterClose={resetTimeModal}
        occupiedRanges={occupiedRange}
        timezoneGmt={timeZone}
        date={date}
      />
    </div>
  );
}
export default Config;
